module.exports = "\n\n\n<iframe src=\"https://blog.wfuneralpeople.com/wp-admin/edit.php\" frameborder=\"0\" height=\"600\" width=\"100%\"></iframe>"